import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../lib/firebase';

/**
 * Fetches all orders from Firestore, sorted by creation date (newest first).
 * Optionally filters by userId if provided.
 */
const useGetOrders = (userId = null) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError(null);
      try {
        console.log('📦 Fetching orders from Firestore...');
        let ordersQuery = query(collection(db, 'orders'), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(ordersQuery);

        if (snapshot.empty) {
          console.warn('⚠️ No orders found in Firestore.');
        }

        const fetchedOrders = snapshot.docs
          .map(doc => {
            const data = doc.data();

            console.log(`🧾 Order [${doc.id}] data:`, {
              userId: data.userId,
              totalAmount: data.totalAmount,
              paymentIntentId: data.paymentIntentId,
              status: data.status,
              createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : null,
              products: data.products?.length ? data.products.map(p => p.name) : [],
              shipping: data.shipping || {},
            });

            return {
              id: doc.id,
              ...data,
            };
          })
          .filter(order => (userId ? order.userId === userId : true)); // optional filtering

        console.log(`✅ Total Orders Fetched: ${fetchedOrders.length}`);
        setOrders(fetchedOrders);
      } catch (err) {
        console.error('🔥 Error fetching orders:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [userId]);

  return { orders, loading, error };
};

export default useGetOrders;
